import { CheckoutSectionProps } from '../../types';

/**
 * A wrapper component for checkout sections with consistent styling.
 * Provides a white background, rounded corners, shadow, and section title.
 */
export function CheckoutSection({ title, children, className = '' }: CheckoutSectionProps) {
  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">{title}</h2>
      {children}
    </div>
  );
}
